<template>
  <modal title="" width="35" :showModal="showModal" @close-modal="closeModal">
    <div class="individual-contaoner">
      <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Status</span></label>
      <el-select @change="getSelectedValue" filterable v-model="filter.status" placeholder="All">
        <el-option v-for="status_ in activeStatusState" :key="status_.name" :label="status_.name"
          :value="status_.value">
        </el-option>
      </el-select>
    </div>


    <div class="flex items-center cursor-pointer mt-5">
      <div>
        <primary-button @click="applyFilter" buttonText="Apply" :loading="loading" />
      </div>
      <div>
        <p @click="closeModal()" class="pl-3">Cancel</p>
      </div>

    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    activeTab: {
      type: String
    }
  },

  data() {
    return {
      loading: false,
      fleets: [],
      routes: [],
      selectedStatus: '',
      activeStatus: [
        { name: 'Pending', value: 'pending' },
        { name: 'Accepted', value: 'accepted' },
        { name: 'Picked up', value: 'picked_up' },
        { name: 'Inbound', value: 'inbound' },
        { name: 'Intransit', value: 'intransit' },
        { name: 'Received', value: 'received' },
        { name: 'Consolidated', value: 'consolidated' },
      ],
      quoteStatus: [
        { name: 'Draft', value: 'draft' },
        { name: 'Estimate', value: 'estimate' },
      ],
      paymentStatus: [
        { name: 'Delivered', value: 'delivered' },
      ],
      recievableStatus: [
        { name: 'Completed', value: 'completed' },
      ],
      filter: {
        route: "",
        fleet: "",
        origin: "",
        status: "",
        costomer: "",
        destination: ""
      },
    };
  },
  computed: {
    activeStatusState() {
      switch (this.activeTab) {
        case 'active':
          return this.activeStatus
        case 'quote':
          return this.quoteStatus
        case 'payment':
          return this.paymentStatus
        case 'recievable':
          return this.recievableStatus
        default:
          return []
      }
    }
  },
  mounted() {
    // this.getFleets();
    // this.getAllRoutes()
  },
  methods: {
    applyFilter() {
      this.$emit("getStatusProps", this.selectedStatus);
      this.closeModal()
    },
    getSelectedValue(val) {
      this.selectedStatus = val
    },
    closeModal() {
      this.$emit("close-modal");
    },
    async getFleets() {
      try {
        let response = await this.$_getAllFleets();

        this.fleets = response.data.data.fleet;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllRoutes() {
      try {
        let response = await this.$_getAll3plLocations();


        this.routes = response.data.data.locations;
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.label {
  @apply border-b-2 border-gray-400 w-full pb-1;
  font-size: 13px;
}

.individual-contaoner {
  @apply w-full border-2 border-gray-300 border-dashed p-2 my-3
}

.filter-search {
  border-radius: 4px;
  @apply py-2
}
</style>